import { AI_INTENTS } from '../../constants/aiSearchIntents';
import { AI_TOPICS } from '../../constants/aiSearchTopics';

const EMERGENCY_VIDEOS = [
  {
    id: 'p_Xw_LaofEQ',
    videoUrl: 'https://www.youtube.com/watch?v=p_Xw_LaofEQ',
    thumbnailUrl: 'https://img.youtube.com/vi/p_Xw_LaofEQ/hqdefault.jpg',
    title: '5 Emergency Skills to Save Your Dog\'s Life',
    source: 'Veterinary Secrets',
  },
  {
    id: 'x3zuZxwCDXs',
    videoUrl: 'https://www.youtube.com/watch?v=x3zuZxwCDXs',
    thumbnailUrl: 'https://img.youtube.com/vi/x3zuZxwCDXs/hqdefault.jpg',
    title: 'DIY First Aid Kit for Cat or Dog',
    source: 'The Bow Tie Vet Guy',
  },
  {
    id: 'IEgSYpsp4-0',
    videoUrl: 'https://www.youtube.com/watch?v=IEgSYpsp4-0',
    thumbnailUrl: 'https://img.youtube.com/vi/IEgSYpsp4-0/hqdefault.jpg',
    title: 'Emergency Wildlife Care: Vet Unit in Action!',
    source: 'SAVE THE ELEPHANTS',
  },
];

const BEHAVIOR_TRAINING_VIDEOS = [
  {
    id: 'sFgtqgiAKoQ',
    videoUrl: 'https://www.youtube.com/watch?v=sFgtqgiAKoQ',
    thumbnailUrl: 'https://img.youtube.com/vi/sFgtqgiAKoQ/hqdefault.jpg',
    title: 'Train your dog to STOP pulling on leash',
    source: 'Kikopup',
  },
  {
    id: '5XxxS7Eh1Ww',
    videoUrl: 'https://www.youtube.com/watch?v=5XxxS7Eh1Ww',
    thumbnailUrl: 'https://img.youtube.com/vi/5XxxS7Eh1Ww/hqdefault.jpg',
    title: 'The FIRST 24 HOURS with a TOTALLY UNTRAINED Pit Bull [Reality Dog Training Episode 1]',
    source: 'Zak George’s Dog Training Revolution',
  },
  {
    id: 'i5tARad4yUI',
    videoUrl: 'https://www.youtube.com/watch?v=i5tARad4yUI',
    thumbnailUrl: 'https://img.youtube.com/vi/i5tARad4yUI/hqdefault.jpg',
    title: 'Training Dogs to Stay Calm: Separation Anxiety',
    source: 'Animal Behavior College',
  },
];

const INTENT_TOPIC_TO_VIDEOS = {
};

const TOPIC_TO_VIDEOS = {
  [AI_TOPICS.PET_TRAVEL]: [
    {
      id: 'eogKwTIsIs8',
      videoUrl: 'https://www.youtube.com/watch?v=eogKwTIsIs8',
      thumbnailUrl: 'https://img.youtube.com/vi/eogKwTIsIs8/hqdefault.jpg',
      title: 'The Ultimate Guide to Traveling with Pets on a Plane',
      source: 'Ben Thoennes Dream Vacations',
    },
    {
      id: '7LgiQOer6UQ',
      videoUrl: 'https://www.youtube.com/watch?v=7LgiQOer6UQ',
      thumbnailUrl: 'https://img.youtube.com/vi/7LgiQOer6UQ/hqdefault.jpg',
      title: 'Flying with Pets in Cabin 2025 - Avoid Mistakes That Cost a Dog His Life',
      source: 'Senior Travel Tips - Bucket List Travel Ideas',
    },
    {
      id: 'uwvtfM1xLLg',
      videoUrl: 'https://www.youtube.com/watch?v=uwvtfM1xLLg',
      thumbnailUrl: 'https://img.youtube.com/vi/uwvtfM1xLLg/hqdefault.jpg',
      title: 'How To Travel Internationally With Your Pet',
      source: 'Marisa Anderson',
    },
  ],
  [AI_TOPICS.PET_STORE]: [],
  [AI_TOPICS.PET_GROOMING]: [],
  [AI_TOPICS.PET_BOARDING]: [],
  [AI_TOPICS.PET_TRAINING]: BEHAVIOR_TRAINING_VIDEOS,
  [AI_TOPICS.PET_ADOPTION]: [],
  [AI_TOPICS.PET_NUTRITION]: [],
  [AI_TOPICS.PET_BEHAVIOR]: [
    {
      id: '2Ex99RuKqAw',
      videoUrl: 'https://www.youtube.com/watch?v=2Ex99RuKqAw',
      thumbnailUrl: 'https://img.youtube.com/vi/2Ex99RuKqAw/hqdefault.jpg',
      title: 'Instantly Improve Your Cat\'s Life with these 7 Things',
      source: 'Jackson Galaxy',
    },
  ],
  [AI_TOPICS.PET_TOXICITY]: EMERGENCY_VIDEOS,
};

export const INTENT_TO_VIDEOS = {
  [AI_INTENTS.MEDICAL_EMERGENCY]: EMERGENCY_VIDEOS,
  [AI_INTENTS.MEDICAL_ROUTINE]: EMERGENCY_VIDEOS,
  [AI_INTENTS.LOST_PET]: [
    {
      id: '4eMAr_jvCck',
      videoUrl: 'https://www.youtube.com/shorts/4eMAr_jvCck',
      thumbnailUrl: 'https://img.youtube.com/vi/4eMAr_jvCck/hqdefault.jpg',
      title: '🐾 7 Things You Didn’t Know Could Help Find Your Lost Dog 🐶 #lostpet #lostdog #missingdog',
      source: 'Buddy Dog Monitor',
    },
  ],
  [AI_INTENTS.FOUND_PET]: [
    {
      id: 'BF8HQTuWGt4',
      videoUrl: 'https://www.youtube.com/shorts/BF8HQTuWGt4',
      thumbnailUrl: 'https://img.youtube.com/vi/BF8HQTuWGt4/hqdefault.jpg',
      title: 'Found a Lost Pet? Here\'s What to Do! #Dog #Cat #animals #pets #call #help',
      source: 'Jason’s Point of View',
    },
  ],
  [AI_INTENTS.FIND_SERVICE]: [],
  [AI_INTENTS.FIND_PLACE]: [],
  [AI_INTENTS.COMMUNITY_QUESTION]: [],
  [AI_INTENTS.OFF_TOPIC]: [],
  [AI_INTENTS.UNKNOWN]: [],
};

export function getVideosFor({ intent, topic } = {}) {
  if (intent && topic) {
    const key = `${intent}::${topic}`;
    if (INTENT_TOPIC_TO_VIDEOS[key]?.length) {
      return INTENT_TOPIC_TO_VIDEOS[key];
    }
  }
  if (topic && TOPIC_TO_VIDEOS[topic]?.length) {
    return TOPIC_TO_VIDEOS[topic];
  }
  if (intent && INTENT_TO_VIDEOS[intent]?.length) {
    return INTENT_TO_VIDEOS[intent];
  }
  return [];
}
